var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPredictable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,70.75H72v-1.5H10.75V8H9.25V70A.7502.7502,0,0,0,10,70.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68,26.75A2.75,2.75,0,1,0,65.25,24,2.7528,2.7528,0,0,0,68,26.75Zm0-4A1.25,1.25,0,1,1,66.75,24,1.25116,1.25116,0,0,1,68,22.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58,44.75A2.75,2.75,0,1,0,55.25,42,2.7528,2.7528,0,0,0,58,44.75Zm0-4A1.25,1.25,0,1,1,56.75,42,1.25116,1.25116,0,0,1,58,40.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48,52.75A2.75,2.75,0,1,0,45.25,50,2.7528,2.7528,0,0,0,48,52.75Zm0-4A1.25,1.25,0,1,1,46.75,50,1.25116,1.25116,0,0,1,48,48.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18,64.75A2.75,2.75,0,1,0,15.25,62,2.7528,2.7528,0,0,0,18,64.75Zm0-4A1.25,1.25,0,1,1,16.75,62,1.25116,1.25116,0,0,1,18,60.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28,62.75A2.75,2.75,0,1,0,25.25,60,2.7528,2.7528,0,0,0,28,62.75Zm0-4A1.25,1.25,0,1,1,26.75,60,1.25116,1.25116,0,0,1,28,58.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38,58.75A2.75,2.75,0,1,0,35.25,56,2.7528,2.7528,0,0,0,38,58.75Zm0-4A1.25,1.25,0,1,1,36.75,56,1.25116,1.25116,0,0,1,38,54.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPredictable);
export default __webpack_public_path__ + "static/media/icon_predictable.f66400c20ba2cc6ca22358b0bbc6e243.svg";
export { ForwardRef as ReactComponent };